import { useState, useEffect, useMemo } from 'react';
import { useTutorials } from 'components/PortalTours/hooks/useTutorials.hook';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useSearchParams } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';

export const useHomePageTutorials = () => {
  const [searchParams] = useSearchParams();
  const { splitTests, introducer } = useIntroducerData();
  const tourType = searchParams.get('tourType');
  const isManualTour = tourType === 'manual';
  const hasAccessToPortalTours =
    getCookie('showPortalTours') ||
    splitTests?.introducer_portal_onboarding_tutorials;
  const hasCreatedApp = introducer?.has_application;

  const { triggerDashboardTour, triggerNavigationTour, shouldShowTour } =
    useTutorials({ autoTriggered: !isManualTour });

  const [isFirstAppModalDismissed, setIsFirstAppModalDismissed] =
    useState(false);
  const [isExistingModalDismissed, setIsExistingModalDismissed] =
    useState(false);

  const showExistingOptInModal = useMemo(
    () =>
      shouldShowTour.existingIntroducerOptIn &&
      !isExistingModalDismissed &&
      !isManualTour &&
      !shouldShowTour.newUser,
    [
      shouldShowTour.existingIntroducerOptIn,
      isExistingModalDismissed,
      isManualTour,
      shouldShowTour.newUser,
    ],
  );

  const showFirstAppModal = useMemo(
    () =>
      shouldShowTour.firstApplication &&
      hasCreatedApp &&
      !isFirstAppModalDismissed &&
      !isManualTour &&
      !shouldShowTour.newUser &&
      !showExistingOptInModal,
    [
      shouldShowTour.firstApplication,
      hasCreatedApp,
      isFirstAppModalDismissed,
      isManualTour,
      shouldShowTour.newUser,
      showExistingOptInModal,
    ],
  );

  useEffect(() => {
    if (shouldShowTour.newUser && hasAccessToPortalTours) {
      triggerNavigationTour();
    }
  }, [shouldShowTour.newUser, hasAccessToPortalTours, triggerNavigationTour]);

  useEffect(() => {
    if (isManualTour && !shouldShowTour.newUser && hasAccessToPortalTours) {
      triggerDashboardTour();
    }
  }, [
    isManualTour,
    shouldShowTour.newUser,
    hasAccessToPortalTours,
    triggerDashboardTour,
  ]);

  return {
    hasAccessToPortalTours,
    showExistingOptInModal,
    showFirstAppModal,
    setIsExistingModalDismissed,
    setIsFirstAppModalDismissed,
    triggerDashboardTour,
  };
};
